import type { DispenseIdentity } from './dispensePreset'
import { parseOpenInAppUrl } from './parseOpenInAppUrl'
import {
  peekPendingIdentity,
  rememberHandledLaunchUrl,
  stashPendingIdentity,
} from './pendingDispenseIdentity'

export function captureOpenInAppUrl (raw: string | null | undefined): DispenseIdentity | null {
  const identity = parseOpenInAppUrl(raw)
  if (!identity) {
    return null
  }

  if (raw && !rememberHandledLaunchUrl(raw, Date.now())) {
    return peekPendingIdentity()
  }

  stashPendingIdentity(identity)
  return identity
}
